import * as React from 'react';

import styles from './CookiePolicyPage.module.css';

export function CookiePolicyPage(): React.ReactElement {
  return (
    <div className={`${styles.cookiePolicyContainer} cookie-policy-container`}>
      <div className={`${styles.policyHeader} policy-header`}>
        <h1>Cookie Policy</h1>
        <h3>Introduction</h3>
        <p>
          This policy covers usage of cookies and other tracking technologies on
          CAE’s websites. When you visit any CAE’s website, it may store or
          retrieve information on your browser, mostly in the form of cookies.
          This information might be about you, your preferences or your device
          and is mostly used to make the site work as you expect it to. The
          information does not usually directly identify you, but it can give
          you a more personalized web experience. Because we respect your right
          to privacy, you can choose not to allow some types of cookies. Below
          is a detailed list of the cookies we use on our website. Our website
          is scanned with our cookie scanning tool regularly to maintain a list
          as accurate as possible. Click on the “Change Cookie Settings” link
          and subsequently on the different category headings to find out more
          and change our default settings. However, blocking some types of
          cookies may impact your experience of the site and the services we are
          able to offer.
        </p>
        <p>
          By clicking “Accept Recommended Settings”, you agree to the usage of
          tracking technologies and the storing of cookies on your device for
          such purposes.
        </p>
      </div>

      <button id="ot-sdk-btn" className="ot-sdk-show-settings">
        Cookie Settings
      </button>
      <br />
      <br />
      <br />

      <div id="ot-sdk-cookie-policy" />

      <div className={`${styles.policyFooter} policy-footer`}>
        <h4>Cookie policy does not cover third-party websites/application</h4>
        <p>
          CAE’s websites may contain links to the sites of third parties or
          parts of their sites. However, CAE has no control over the content or
          operation of these sites, nor does it control the confidentiality or
          privacy practices of the site operators. It is therefore your
          responsibility to find out about their policies in order to protect
          information that concerns you.
        </p>
      </div>
    </div>
  );
}
